import { createAction, createReducer } from "@reduxjs/toolkit";
import { type GradeSelectorLabelType, gradeSelectorLabels } from "../../utils/labels";
import { GradeSelectorSortMode, type GradeSelectorSortModeType } from "../../utils/types/Sort";

export type GradeSelectorSettingsType = {
    initialized: boolean;
    labels: Record<GradeSelectorLabelType, string>;
    showETA: boolean;
    etaMatchingType: string; // Determines which cars are returned for ETA, see https://t1-preview-wiki.toyota-europe.com/index.php/CarConfig_Settings#summaryEtaMatchingType
    sortMethod: GradeSelectorSortModeType; // Determines how the cars are sorted in the grade selector
    enableSpeedboatUrl: boolean; // If true, the speedboat URL will be used for the car config
};

export const initialStateGradeSelectorSettings: GradeSelectorSettingsType = {
    initialized: false,
    labels: { ...gradeSelectorLabels },
    showETA: false,
    etaMatchingType: "",
    sortMethod: GradeSelectorSortMode.OrderBySubModelGradePrice,
    enableSpeedboatUrl: false,
};

export const initGradeSelectorSettings = createAction<GradeSelectorSettingsType, "gradeSelectorSettings/init">(
    "gradeSelectorSettings/init",
);

export type GradeSelectorSettingsActionTypes = ReturnType<typeof initGradeSelectorSettings>;

const GradeSelectorSettingsReducer = createReducer(initialStateGradeSelectorSettings, (builder) => {
    builder.addCase(initGradeSelectorSettings, (state, action) => {
        return {
            ...state,
            ...action.payload,
            initialized: true,
        };
    });
});

export default GradeSelectorSettingsReducer;
